import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import HCLAppscanMappingForm from "./HCLAppscanMappingForm";

const HCLAppscanCredentialsForm = (props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API URL",
      required: true,
      rules: [urlRegexValidator]
    },
    {
      name : "keyId",
      label : "Key Id",
      required : true,
    },
    {
      name: "keySecret",
      label: "Key Secret",
      type: FieldTypes.PASSWORD,
      required: true,
    }
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={HCLAppscanMappingForm}
    />
  );
};

export default forwardRef(HCLAppscanCredentialsForm);
